import WrapperEntitySelector from '@modules/entitySelector/WrapperEntitySelector';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { IEntitySelectorWrapperProps } from '@ts/storybook';

interface IUserLabelsSelection<Multiple extends boolean> extends Omit<IEntitySelectorWrapperProps<Multiple>, 'searchComponent'> {}

const UserLabelsSelection = <Multiple extends boolean>(props: IUserLabelsSelection<Multiple>) => {
  return (
    <WrapperEntitySelector
      {...props}
      searchComponent={generateSearchEntitySelector('tag', { where: { restrictedToEntities: 'taUser' } })}
    />
  );
};

export default UserLabelsSelection;
